import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  peoplePageHeader: {
    padding: "0 0 26px 0"
  },
  title: {
    color: colors.lightBlack,
    fontWeight: "600",
    fontSize: "30px",
    lineHeight: "38px",
    padding: "0 0 0 12px",
    marginBottom: 0
  },
  container: {
    margin: 0,
    padding: 0,
    maxWidth: "100%",
  },
  skeletonName: {
    backgroundColor: colors.darkGrey,
    "--base-color": colors.darkGrey,
  },
  titleBadgeWrapper: {
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      display: "grid",
      textAlign: "left"
    },
  },
  badgeWrapper: {
    display: "flex",
    gap: "4px",
    height: "fit-content",
    alignItems: "center",
    textAlign: "center",
    padding: "2px 10px 2px 8px",
    backgroundColor: colors.blueLight50,
    borderRadius: "16px",
    marginLeft: "16px",
    "& p": {
      color: colors.blueLight700,
      fontWeight: "500",
      fontSize: "14px",
      lineHeight: "20px",
      margin: "0px"
    },
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      marginTop: "12px",
      width: "fit-content",
      marginRight: "13px"
    },
  }
}));

export default styles;
